<template lang="pug">
.socialCard(:class="`is-${icon} is-ratio-${ratio}`")
  .socialCard-body
    AppIcon.socialCard-icon(:name="icon")
    p(v-if="desc") {{desc}}
    AppLink(class="button is-wide is-white is-rounded  is-inverse u-mb-0" :to="url") {{$t('follow')}}

</template>

<script>
export default {
  name: 'SocialCard',
  props: {
    desc: {
      type: String,
      default: null
    },
    ratio: {
      type: String,
      default: '1-1'
    },
    name: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="stylus">
.socialCard
  background: $clBlack
  color: $clWhite
  padding-top: 100%
  position: relative
  min-height: 360px

  &-body
    align-items: center
    justify-content: center
    display: flex
    flex-direction: column
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%

  p
    max-width: 80%
    text-align: center
    margin-bottom: unitRes(20, 40)

  &-icon
    font-size: unitRes(60, 120)
    width: 1em
    height: 1em
    margin-bottom: unitRes(20, 40)

  &.is-behance
    background: #0057ff

  &.is-twitter
    background: #38A1F3

  &.is-github
    background: #333

  &.is-facebook
    background: #3b5998

  &.is-pinterest
    background: #bd081c

  &.is-dribbble
    background: #ea4c89

  &.is-vimeo
    background: #1ab7ea

  &.is-linkedin
    background: #0077b5

  &.is-ratio-2-1
    padding-top: aspectRatio(2, 1)

  &.is-ratio-3-1
    padding-top: aspectRatio(3, 1)

  &.is-ratio-3-2
    padding-top: aspectRatio(3, 2)

  &.is-ratio-3-4
    padding-top: aspectRatio(3, 4)

  &.is-ratio-4-5
    padding-top: aspectRatio(4, 5)

  &.is-ratio-5-2
    padding-top: aspectRatio(5, 2)

  &.is-ratio-5-3
    padding-top: aspectRatio(5, 3)

  &.is-ratio-5-4
    padding-top: aspectRatio(5, 4)

  &.is-ratio-7-5
    padding-top: aspectRatio(7, 5)

  &.is-ratio-16-9
    padding-top: aspectRatio(16, 9)
</style>

<i18n>
{
  "en": {
    "follow":"Follow us"
  },
  "ar": {
    "follow":"تابعنا"
  }
}
</i18n>
